export default {
    messages: {
      alpha_spaces: () => 'Only alphabets and spaces are allowed.',
    },
    attributes: {
      first_name: 'first name',
      last_name: 'last name',
      designation: 'Job title ',
      company :'organisation ',
      employ_count :'employee number',
      confirm_password :'re-type password',
      agree:'agree to the terms of service and privacy policy'
    }
}



// WEBPACK FOOTER //
// ./lang/en/validation.js